import { fetchApiGateway } from "@nova/fetch-api-gateway"
import { CustomFieldSpec } from "@nova/schemas"
import { useSWRNoRevalidate } from "@nova/swr"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { useAppSelector } from "integrations/redux/hooks"
import { mutate } from "swr"
import useSWRMutation from "swr/mutation"

export const invalidateCustomFieldDefinition = () =>
    mutate((key) => Array.isArray(key) && key[0] === "get-custom-field-definition")

const getCustomFieldDefinition = ({ orgId }: { orgId: string }) => {
    return fetchApiGateway("get /org/:orgId/fleet/custom-field-definition", {
        params: { orgId },
    })
}

export const useCustomFieldDefinition = () => {
    const orgId = useAppSelector(selectActiveWorkspaceId())

    const { data, isLoading } = useSWRNoRevalidate(["get-custom-field-definition", orgId], () =>
        orgId ? getCustomFieldDefinition({ orgId }) : undefined
    )

    return { data, isLoading }
}

const upsertCustomFieldDefinition = ({
    orgId,
    form,
}: {
    orgId: string
    form: CustomFieldSpec[]
}) => {
    return fetchApiGateway("put /org/:orgId/fleet/custom-field-definition", {
        body: { form },
        params: { orgId },
    })
}

export const useUpsertCustomFieldDefinition = () => {
    const orgId = useAppSelector(selectActiveWorkspaceId())

    const { trigger, isMutating } = useSWRMutation(
        "upsert-custom-field-definition",
        (key, { arg }: { arg: { form: CustomFieldSpec[] } }) =>
            orgId ? upsertCustomFieldDefinition({ orgId, form: arg.form }) : undefined,
        { onSuccess: invalidateCustomFieldDefinition }
    )

    return { upsertCustomFieldDefinition: trigger, isMutating }
}

const deleteCustomFieldDefinition = ({ orgId }: { orgId: string }) => {
    return fetchApiGateway("delete /org/:orgId/fleet/custom-field-definition", {
        params: { orgId },
    })
}

export const useDeleteCustomFieldDefinition = () => {
    const orgId = useAppSelector(selectActiveWorkspaceId())

    const { trigger, isMutating } = useSWRMutation(
        "delete-custom-field-definition",
        () => (orgId ? deleteCustomFieldDefinition({ orgId }) : undefined),
        { onSuccess: invalidateCustomFieldDefinition }
    )

    return { deleteCustomFieldDefinition: trigger, isMutating }
}
